import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 1,
  id: "playback-play-pause-button"
}
const _hoisted_2 = {
  key: 0,
  id: "playback-reverse-time"
}
const _hoisted_3 = { id: "reverse-button-text" }
const _hoisted_4 = { id: "playback-slider-container" }
const _hoisted_5 = { id: "tick-container" }
const _hoisted_6 = { class: "tick-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_icon_button = _resolveComponent("icon-button")!
  const _component_v_slider = _resolveComponent("v-slider")!

  return (_openBlock(), _createElementBlock("div", {
    id: "enclosing-playback-container",
    style: _normalizeStyle(_ctx.cssVars)
  }, [
    ((_ctx.inline && _ctx.inlineButton) || _ctx.showCloseButton)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "playback-close-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, [
          _createVNode(_component_v_icon, {
            color: _ctx.color,
            size: "18"
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("mdi-close")
            ])),
            _: 1
          }, 8, ["color"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.inline || _ctx.inlineButton && !_ctx.hidePlayButton)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_icon_button, {
            "md-icon": _ctx.isPaused ? 'mdi-play' : 'mdi-pause',
            onActivate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isPaused = !_ctx.isPaused)),
            color: _ctx.color,
            "focus-color": _ctx.color,
            "tooltip-text": "Play/Pause",
            "tooltip-location": "top",
            "tooltip-offset": "5px",
            "md-size": "18"
          }, null, 8, ["md-icon", "color", "focus-color"]),
          (!_ctx.inline || _ctx.inlineButton)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_icon_button, {
                  onActivate: _cache[2] || (_cache[2] = ($event: any) => (_ctx.reverseTime = !_ctx.reverseTime)),
                  "md-icon": _ctx.reverseTime ? 'mdi-step-forward-2' : 'mdi-step-backward-2',
                  color: _ctx.color,
                  "focus-color": _ctx.color,
                  "tooltip-text": "Forward/Reverse",
                  "tooltip-location": "top",
                  "tooltip-offset": "5px",
                  "md-size": "18"
                }, null, 8, ["md-icon", "color", "focus-color"]),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.reverseTime ? 'Forward' : 'Reverse'), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.index, (val) => {
          return (_openBlock(), _createElementBlock("div", _mergeProps({
            key: val,
            ref_for: true
          }, _ctx.options(val), { class: "tick" }), [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.valueToMark(val)), 1)
          ], 16))
        }), 128))
      ]),
      _createVNode(_component_v_slider, {
        ref: "slider",
        "hide-details": "",
        modelValue: _ctx.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.value) = $event)),
        max: _ctx.max ?? _ctx.index[_ctx.index.length - 1],
        min: _ctx.min ?? _ctx.index[0],
        "thumb-size": 16,
        color: "white",
        "track-color": "white",
        "track-fill-color": "white",
        "thumb-color": "blue",
        "track-size": "8",
        step: _ctx.step,
        "show-ticks": _ctx.useBuiltInTicks ? 'always' : false,
        ticks: _ctx.useBuiltInTicks ? _ctx.marks : undefined
      }, null, 8, ["modelValue", "max", "min", "step", "show-ticks", "ticks"])
    ])
  ], 4))
}